import React from "react";

import "./mobile-freebie-cart-line-style.scss";

import Typography from "@src/componentsNew/Typography/Typography";

import { CartSubCartsLinesType } from "@src/utils/types";
import { checkoutQuery_checkout_subcarts_lines } from "@components/pages/CheckoutPage/__generated__/checkoutQuery";

interface IProps {
  line: CartSubCartsLinesType | checkoutQuery_checkout_subcarts_lines;
}

const MobileFreebieCartLine = ({ line }: IProps) => {
  return (
    <div className="mobile-freebie-cart-line-wrapper">
      <Typography cName="brand-name" variant="body3" component="span" style={{ color: "#212121" }}>
        {`[${line?.variant?.product?.brand}] ${line?.variant?.product?.name}`}
      </Typography>

      <div className="freebie-cart-line-product-wrapper">
        <img
          className="product-image"
          src={line?.variant?.product?.thumbnail?.url}
          alt={line?.variant?.product?.thumbnail?.alt}
        />

        <div className="product-description-wrapper">
          {
            line?.variant?.name && (
              <Typography variant="caption" component="span" style={{ color: "#11141D99" }}>
                {line?.variant?.name}
              </Typography>
            )
          }

          <Typography variant="body2" component="span" style={{ color: "#11141D99" }}>
            {`Qty : ${line?.quantity}`}
          </Typography>
        </div>
      </div>
    </div >
  );
};

export default MobileFreebieCartLine;
